import React from 'react';
import { TextField as MuiTextField, TextFieldProps } from '@mui/material';

export const TextField = React.forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  return <MuiTextField inputRef={ref} fullWidth margin={'dense'} {...props} />;
}) as typeof MuiTextField;
